import { apiClient as api } from "./httpClient";
import { Plano } from "../interfaces/Plano";
import { CreatePlanoRequest } from "../interfaces/CreatePlanoRequest";

export const planoService = {
  getAllPlanos: async (): Promise<Plano[]> => {
    const response = await api.get("/Plan/legacy");
    return response.data?.items ?? (Array.isArray(response.data) ? response.data : []);
  },
  createLegacyPlano: async (plano: CreatePlanoRequest): Promise<Plano> => {
    const response = await api.post("/Plan/legacy", plano);
    return response.data;
  },
  updateLegacyPlano: async (id: string, plano: CreatePlanoRequest): Promise<Plano> => {
    const response = await api.put(`/Plan/legacy`, plano);
    return response.data;
  },
  deleteLegacyPlano: async (id: string): Promise<void> => {
    await api.delete(`/Plan/legacy/${id}`);
  },
};
